import { EnumHelperBase, type EnumDataObject } from './enum.helpers';

export enum CURRENCY {
	CZK = 1,
	EUR = 2,
	RSD = 3,
	GBP = 4,
	PLN = 5,
}

export interface CurrencyEnumBaseData extends EnumDataObject<CurrencyEnumBaseExtraData, CURRENCY, 'currencyId'> {}

export interface CurrencyEnumBaseExtraData {
	isoChar: string;
	isoNum: string;
}

/**
 * Base Currency enumeration
 * @see https://github.com/NFCtron/nfctron-db/blob/dev/diagrams/global.png
 */
class CurrencyEnumBase extends EnumHelperBase<CurrencyEnumBaseExtraData, CURRENCY, 'currency', 'currencyId'> {
	constructor() {
		super(
			'currency',
			{
				[CURRENCY.CZK]: { isoChar: 'CZK', isoNum: '203' },
				[CURRENCY.EUR]: { isoChar: 'EUR', isoNum: '978' },
				[CURRENCY.RSD]: { isoChar: 'RSD', isoNum: '941' },
				[CURRENCY.GBP]: { isoChar: 'GBP', isoNum: '826' },
				[CURRENCY.PLN]: { isoChar: 'PLN', isoNum: '985' },
			},
			'currencyId',
			null,
		);
	}
}

export const currencyEnumBase = new CurrencyEnumBase();
